/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Create or update venue transfer route request.
 */
export interface VenueTransferRouteRequest {
  sourceVenue: VenueTransferRouteRequest.SourceVenueEnum;
  /**
   * Our account representing source venue account
   */
  sourceAccountId: number;
  destinationVenue: VenueTransferRouteRequest.DestinationVenueEnum;
  /**
   * Our account representing destination venue account
   */
  destinationAccountId: number;
  assetId: number;
  /**
   * Network, e.g. ERC20, BANK
   */
  network: string;
  /**
   * Network/method code of source venue API, e.g. Kraken method id
   */
  sourceNetworkCode?: string;
  /**
   * Static source, e.g. bank account name
   */
  sourceAddress?: string;
  /**
   * Blockchain address or bank account name
   */
  destinationAddress?: string;
  memo?: string;
  /**
   * Destination reference registered on source venue, e.g. Kraken address id
   */
  sourceDestinationRef?: string;
  /**
   * False to deactivate route
   */
  active: boolean;
}
export namespace VenueTransferRouteRequest {
  export const SourceVenueEnum = {
    Kraken: 'KRAKEN',
    Okx: 'OKX',
    Zerohash: 'ZEROHASH',
    CustomersBank: 'CUSTOMERS_BANK',
    Fireblocks: 'FIREBLOCKS',
  } as const;
  export type SourceVenueEnum = (typeof SourceVenueEnum)[keyof typeof SourceVenueEnum];
  export const DestinationVenueEnum = {
    Kraken: 'KRAKEN',
    Okx: 'OKX',
    Zerohash: 'ZEROHASH',
    CustomersBank: 'CUSTOMERS_BANK',
    Fireblocks: 'FIREBLOCKS',
  } as const;
  export type DestinationVenueEnum = (typeof DestinationVenueEnum)[keyof typeof DestinationVenueEnum];
}
